export const Space = 'Space';
